const header = document.querySelector('.header');
const bodyElement = document.querySelector('body');
let blockEles = document.querySelectorAll('.animate');
const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
const cta = document.querySelector('.cta');

// simplify the animations for IE11
const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
const ua = window.navigator.userAgent;
const edge = ua.indexOf('Edge/');
if (isIE11 || edge > 0) {
    bodyObj.classList.add('ie-anims');
} 
if (edge > 0) {
    bodyObj.classList.add('ie-edge-anims');
}

const lastLcpBlock = document.querySelectorAll('.animate.lcp.fcp');
const lcpBlocks = blockEles;

scrollStickyHeader();
processLcpBlocks();

window.addEventListener('scroll', function() {
    scrollStickyHeader();
    animateBlocks();
}, false);

function scrollStickyHeader() {
    const header = document.querySelector('header');
    const mediaBreakPoint = '(max-width: 1024px)';
    const mq = window.matchMedia(mediaBreakPoint);
    const scrollPosY = window.pageYOffset || document.documentElement.scrollTop;

    const removeScrolling = function (mq) {
        if (mq.matches) {
            if (header.classList.contains('scrolling')) {
                header.classList.remove('scrolling');
            }
        } else if (!mq.matches) {
            if (scrollPosY > 1 && !header.classList.contains('scrolling')) {
                header.classList.add('scrolling');
                cta && cta.classList.add('scrolling-top-padding');
            } else if (scrollPosY <= 1 && header.classList.contains('scrolling')) {
                header.classList.remove('scrolling');
                cta && cta.classList.remove('scrolling-top-padding');
            }
        }
    }

    mq.addListener(removeScrolling);
    removeScrolling(mq);
}

function animateBlocks(delayOffset = 0) {
    let delayCounter = delayOffset;
    let domNegate = (windowHeight / 8);
    if (domNegate > 100) {
        domNegate = 100;
    }

    blockEles.forEach(blockEl => {
        let domBounds = blockEl.getBoundingClientRect();
        // don't override current styles
        let currentStyles = blockEl.getAttribute('style');
        if (!currentStyles) {
            currentStyles = '';
        }
        // process animation silently (don't animate things above the scrolled fold)
        if (domBounds.top < 0 && !blockEl.hasAttribute('data-animate')) {
            blockEl.setAttribute('data-animate', 'true');
            blockEl.setAttribute('style', currentStyles + '; transition-delay: 0s; animation-delay: 0s;');
        }
        // animate if in the viewport and if data animate is not already set
        if (domBounds.top <= (windowHeight - domNegate) && !blockEl.hasAttribute('data-animate')) {
            // largest paint check (reset delay to 0)
            if (blockEl.classList.contains('fmp')) {
                delayCounter = 0.01;
            }
            blockEl.setAttribute('data-animate', 'true');
            blockEl.setAttribute('style', currentStyles + 'transition-delay: ' + delayCounter + 's; animation-delay: ' + delayCounter + 's;');

            delayCounter = delayCounter + 0.15; // 0.15s increase per animation
        }
    });
}

function processLcpBlocks() {
    if (lcpBlocks) {
        let sizeTotal = 0;
        let largestItem = 0;
        let sizeTmp = 0;
        let sizeTempHeight = 0;
        let sizeTempWidth = 0;
        let tempBounds = 0;
        
        for (var i = 0; i < lcpBlocks.length; i++) {
            sizeTempHeight = lcpBlocks[i].clientHeight;
            tempBounds = lcpBlocks[i].getBoundingClientRect();
            sizeTempWidth = lcpBlocks[i].clientWidth;

            // if in viewport
            if (tempBounds.top <= windowHeight) {
                lcpBlocks[i].classList.add('visible');
                // if bigger than last biggest element
                if (sizeTmp > sizeTotal) {
                    sizeTotal = sizeTmp;
                    largestItem = i;
                }
            }
        }

        if (largestItem > -1 && lcpBlocks.length) {
            lcpBlocks[largestItem].classList.add('fmp');
        }
        
        // animate blocks after processing
        animateBlocks();
    }
}

const blogSearchResults = document.querySelector('#blogResultsList');
if (blogSearchResults) {
    const observer = new MutationObserver(mutationCallback);
    observer.observe(blogSearchResults, {
        attributes: false,
        subtree: true,
        childList: true,
        characterData: false
    })
    
    function mutationCallback() {
        if (blogSearchResults.childNodes.length) {
            blockEles = document.querySelectorAll('.animate');
            animateBlocks();
            // observer.disconnect();
        }
    }
}